var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8AAD43B9-9AC8-4F08-A269-27063C84E83E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reactions_main",
    transform: "translate(-20.000000, -113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(20.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#2C2F49",
    strokeWidth: 1.5,
    fill: "#2C2F49",
    cx: 12,
    cy: 12,
    r: 11.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4649472,12.2260376 L4.62734863,14.0960486 C3.8655178,14.8713169 2.63179168,14.8713169 1.87060049,14.0962036 C1.109257,13.3214312 1.109257,12.0658201 1.87044819,11.2912026 L5.54628498,7.5505298 C6.30747618,6.77588139 7.54132413,6.77588139 8.30251532,7.5505298 C8.55626603,7.80875628 8.96770097,7.80875628 9.22145168,7.5505298 C9.47520238,7.29230333 9.47520238,6.87361132 9.22145168,6.61538485 C7.95272861,5.32428348 5.89607169,5.32428348 4.62734863,6.61538485 L0.951542298,10.3560267 C-0.317180766,11.647128 -0.317180766,13.7400612 0.951542298,15.0311625 C2.22011307,16.3229458 4.27692228,16.3229458 5.54631544,15.0311625 L7.38391402,13.1611516 C7.63766472,12.9029251 7.63766472,12.4842331 7.38391402,12.2260066 C7.13016331,11.9677802 6.71869791,11.9678112 6.4649472,12.2260376 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9926016,1.01960671 C13.6494037,-0.339868903 11.4713103,-0.339868903 10.1281123,1.01960671 L7.79397787,3.38202767 C7.52533184,3.65392932 7.52533184,4.09479446 7.79397787,4.36669611 C8.0626239,4.63859776 8.49821034,4.63859776 8.76685637,4.36669611 L11.1009908,2.00427515 C11.9068644,1.18860284 13.2138172,1.18860284 14.0197231,2.00427515 C14.8255967,2.81991483 14.8255967,4.14202069 14.0197231,4.95766037 L9.73944465,9.2898425 C8.9335388,10.1055148 7.62729544,10.1055148 6.82142184,9.2898425 C6.55277581,9.01794085 6.11718938,9.01794085 5.84854335,9.2898425 C5.57989732,9.56174415 5.57989732,10.0026093 5.84854335,10.2745109 C7.19174125,11.6339866 9.36912524,11.6339866 10.7123231,10.2745109 L14.9926016,5.94236144 C16.3357995,4.58288583 16.3357995,2.37908232 14.9926016,1.01960671 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActive);
export default __webpack_public_path__ + "static/media/like_active.2f0228f9a57557d76b62da36f4c04142.svg";
export { ForwardRef as ReactComponent };